import { useState, useEffect } from 'react';
import {
  useLocationLegacy as useLocation,
  useNavigateLegacy as useNavigate,
} from '@leagueplatform/routing';
import { SHOW_PULSE_CHECK_MODAL } from '#constants/health-program-modal.constants.js';

interface LocationState {
  type?: string;
  programId?: string;
}

export const useLeaveProgramModal = () => {
  const navigate = useNavigate();
  const location = useLocation<LocationState>();
  const [showLeaveProgramPulseCheck, setShowLeaveProgramPulseCheck] = useState(
    location?.state?.type === SHOW_PULSE_CHECK_MODAL,
  );

  const [leaveProgramPulseCheckState] = useState(location.state);
  useEffect(() => {
    if (showLeaveProgramPulseCheck) {
      navigate(location.pathname, { replace: true, state: { type: '' } });
    }
  }, [navigate, location.pathname, showLeaveProgramPulseCheck]);

  return {
    showLeaveProgramPulseCheck,
    setShowLeaveProgramPulseCheck,
    leaveProgramPulseCheckState,
  } as const;
};
